import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard }                from './auth/auth.guard';
import  { AuthGuardAdmin } from './auth/auth.admin.guard.1'
const routes: Routes = [{path:'i18n', loadChildren:'./dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
{path:'Home', loadChildren:'./scv-home/scv-home.module#ScvHomeModule', canActivate: [AuthGuard]},
{path:'Admin', loadChildren:'./admin/admin.module#AdminModule', canActivate:[AuthGuard, AuthGuardAdmin]},
{path: '',
redirectTo: '/',
pathMatch: 'full'
},];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
